// eslint-disable-next-line import/no-unresolved
require('./lib/initialize');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dates/initialize.js
// module id = 1426
// module chunks = 0